import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrl, buildAuthHeadersForFetch } from "./RestService";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IVendorModel from "../models/IVendorModel";
import IResendCustomMessageDTO from "../models/DTO/IResendCustomMessageDTO";

const resendCustomMessage = async (
    orderGuid: string,
    dto: IResendCustomMessageDTO,
    userModel: IUserUI,
    supplierModel: ISupplierModel,
    vendorModel?: IVendorModel
): Promise<any> => {
    const url = buildRestUrl({
        endpoint: RestEndpointsEnum.ResendCustomMessage,
        params: { orderGuid },
    });

    const headers = buildAuthHeadersForFetch({ userModel, supplierModel, vendorModel });

    const response = await fetch(url, {
        method: "POST",
        headers: {
            ...headers,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(dto),
    });

    if (!response.ok) {
        throw new Error(`Failed to resend custom message: ${response.statusText}`);
    }

    return await response.json();
};

const OrderMessageService = {
    resendCustomMessage,
};

export default OrderMessageService;
